<!--
* UIID: UI-DLB-FF-110 / UI-DLB-FF-120
* UI Name: Add FlatFile Layout / Modify FlatFile Layout
* Modify Date: 2020/06/9
-->
<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="dialog-drag-display add-map-layout-dialog custom-add-map-layout-dialog"
  >
    <template v-slot:title>
      <!-- [S]  Popup title-->
      <v-card-title
        class="headline white--text"
        primary-title
      >{{options.item.action == 'add' ? 'Add FlatFile Layout' : 'Modify FlatFile Layout'}}</v-card-title>
    </template>
    <template v-slot:button-close>
      <v-btn small text icon @click="removeDialog">
        <icon-svg iconName="close" />
      </v-btn>
      <!-- <v-icon class="ma-2" small @click="removeDialog" color="white">fas fa-times</v-icon> -->
    </template>
    <v-card class="dialog-container">
      <!-- [S]  Popup body-->
      <v-card-text class="pb-0">
        <v-form ref="form" class="dialog-content">
          <v-row class="ml-0 mr-0">
            <v-col class="required-col field-col pt-0" lg="2">
              <v-icon x-small>fas fa-asterisk</v-icon>
              <span
                class="field-label required-text pl-1"
              >{{$t('lbl.flatFileLayout.addFlatFile.flatFile')}}</span>
            </v-col>
            <v-col v-if="options.item.action != 'add'" lg="10" class="map-text-field pl-0 pt-0">
              <v-text-field
                v-model="addFlatFileLayoutHeader.data[0].FFL_FILE_STR"
                ref="refFlatFile"
                :rules="[validationUtils.required]"
                class="data-table-filter-text-field text-field-flatfile-layout readonly-textfield"
                heigth="30"
                readonly
                outlined
                dense
                solo
              ></v-text-field>
            </v-col>
            <v-col
              v-if="options.item.action == 'add'"
              class="map-text-field inline-block-component pl-0 pt-0"
              lg="10"
            >
              <v-text-field
                v-model="addFlatFileLayoutHeader.data[0].FFL_FILE_STR"
                ref="refFlatFile"
                :rules="[validationUtils.required]"
                class="data-table-filter-text-field inline-block-component text-field-flatfile-layout flatfile-textfield"
                heigth="30"
                outlined
                dense
                solo
                readonly
              ></v-text-field>
              <input
                id="flatfile_layout_input"
                ref="flatfile_layout_input"
                @change="onFlatFileChanged"
                type="file"
                style="display: none"
              />
              <v-btn
                @click="clickBrowseFlatFile()"
                class="btn btn-popup-search"
                color="primary"
              >{{$t('btn.common.browse')}}</v-btn>
            </v-col>
          </v-row>
          <v-row class="ml-0 mr-0">
            <v-col class="required-col field-col" lg="2">
              <v-icon x-small hidden>fas fa-asterisk</v-icon>
              <span
                class="field-label required-text pl-1"
              >{{$t('lbl.flatFileLayout.addFlatFile.comment')}}</span>
            </v-col>
            <v-col lg="10" class="map-text-field pl-0">
              <v-text-field
                v-model="addFlatFileLayoutHeader.data[0].CHKIN_COMT"
                ref="comment_textfield"
                :class="['data-table-filter-text-field', 'text-field-flatfile-layout', options.item.action != 'add' ?  'readonly-textfield' : '']"
                :readonly="options.item.action == 'add' ? false : true"
                :rules="[validationUtils.required]"
                heigth="30"
                outlined
                dense
                solo
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ml-0 mr-0">
            <v-col class="not-required-col field-col" lg="2">
              <span
                class="field-label required-text"
              >{{$t('lbl.flatFileLayout.addFlatFile.businessName')}}</span>
            </v-col>
            <v-col lg="10" class="map-text-field pl-0">
              <v-autocomplete
                v-model="addFlatFileLayoutHeader.data[0].SVC_ID"
                :items="businessNameList"
                class="custom-selectbox edi-mes-list"
                dense
                solo
                hide-details
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row class="ml-0 mr-0">
            <v-col class="not-required-col field-col" lg="2">
              <span
                class="field-label required-text"
              >{{$t('lbl.flatFileLayout.addFlatFile.csvFile')}}</span>
            </v-col>
            <v-col lg="10" class="map-text-field inline-block-component pl-0">
              <v-text-field
                v-model="addFlatFileLayoutHeader.data[0].CSV_FILE_STR"
                class="data-table-filter-text-field inline-block-component text-field-flatfile-layout flatfile-textfield"
                heigth="30"
                outlined
                hide-details
                dense
                solo
                readonly
              ></v-text-field>
              <input
                type="file"
                ref="csv_file_input"
                @change="onCsvFileChanged"
                style="display: none"
              />
              <v-btn
                @click="clickBrowseCsvFile()"
                class="btn btn-popup-search"
                color="primary"
              >{{$t('btn.common.browse')}}</v-btn>
            </v-col>
          </v-row>
          <v-row class="ml-0 mr-0">
            <v-col class="not-required-col field-col pb-0" lg="2">
              <span class="field-label required-text">{{$t('lbl.flatFileLayout.addFlatFile.type')}}</span>
            </v-col>
            <v-col lg="3" class="map-text-field pl-0 pb-0">
              <v-select
                v-model="addFlatFileLayoutHeader.data[0].FFL_FRMT_TP"
                :items="typeList"
                class="data-table-select-box srm-select-box custom-selectbox flatfile-layout-selectbox communication-select-box pt-0 pl-select"
                height="30"
                hide-details
                dense
                solo
                outlined
              ></v-select>
            </v-col>
          </v-row>
        </v-form>
        <v-divider class="ml-0 mr-0 divder-popup" inset></v-divider>
        <v-row class="ml-0 mr-0">
          <v-col class="button-col action-col" lg="12">
            <div class="btn-form-control text-right">
              <v-btn class="btn btn-delete btn-popup" @click="removeDialog">
                <!-- <v-icon small color="white" class="mr-1">fa fa-times</v-icon> -->
                {{$t('btn.common.close')}}
              </v-btn>
              <v-btn class="btn btn-popup-search btn-popup" color="primary" @click="onSave">
                <!-- <v-icon x-small class="mr-2">fas fa-save</v-icon> -->
                {{$t('btn.common.save')}}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- [E]  Popup body-->
    </v-card>
  </dialog-drag>
</template>

<script>
import DialogDrag from "@/vue-dlb/components/vue-dialog-drag.vue";
import { mapState } from "vuex";
import cfg from "@/vue-caas/config/config.js";
import IconSvg from "@/vue-caas/components/IconBase.vue";

export default {
  components: {
    DialogDrag,
    IconSvg,
  },
  name: "add-flatfile-layout-dialog",
  // props: ['id', 'title', 'options', 'eventCb', 'closeDialog', 'dragStart', 'dragEnd'],
  props: {
    id: String,
    title: String,
    options: Object,
    eventCb: Function,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
  },
  computed: {
    ...mapState("common", {
      bizCodeList: "bizCodeList",
      codeList: "codeList",
      repomenuMode: "repomenuMode",
    }),
    ...mapState("fflayout", {
      mainGrid: "mainGrid",
    }),
  },
  data() {
    return {
      /* Remove unuse code
    value: null,
    contenInput: '',
    add_valid_str: '',
    item: {
      flatfile: '',
      comment: '',
      csv_file: ''
    },
    */
      ACCESS_REPO_YN: "", // common mandatory for ADMIN_YN
      businessNameList: [
        {
          text: "text",
          value: "value",
        },
      ],
      typeList: ["text"],
      addFlatFileLayoutHeader: {
        header: [
          "FFL_PRCS_NO",
          "ADMIN_YN",
          "CUST_ID",
          "OWNR_CUST_ID",
          "USER_ID",
          "REPO_YN",
          "SVC_ID",
          "FFL_FRMT_TP",
          "FFL_FILE_NAME",
          "FILE_ID",
          "FILE_SIZE",
          "CSV_FILE_NAME",
          "CSV_FILE_ID",
          "CHKIN_COMT",
          "fflfile",
          "csvfile",
        ],
        data: [
          {
            FFL_PRCS_NO: "",
            ADMIN_YN: "",
            CUST_ID: "",
            OWNR_CUST_ID: `${$cookies.get("ownr-id")}`,
            USER_ID: `${$cookies.get("comp-id")}`,
            REPO_YN: "N",
            SVC_ID: "",
            FFL_FRMT_TP: "",
            FFL_FILE_NAME: "",
            FILE_ID: "",
            FILE_SIZE: "",
            CSV_FILE_NAME: "",
            CSV_FILE_ID: "",
            CHKIN_COMT: "",
            fflfile: null,
            csvfile: null,
            CSV_FILE_STR: "",
            FFL_FILE_STR: "",
          },
        ],
      },

      updateFlatFileLayoutHeader: {
        header: [
          "FFL_PRCS_NO",
          "CUST_ID",
          "USER_ID",
          "SVC_ID",
          "FFL_FRMT_TP",
          "CSV_FILE_NAME",
          "CSV_FILE_ID",
          "csvfile",
        ],
        data: [
          {
            FFL_PRCS_NO: "",
            CUST_ID: "",
            USER_ID: "",
            SVC_ID: "",
            FFL_FRMT_TP: "",
            CSV_FILE_NAME: "",
            CSV_FILE_ID: "",
            csvfile: null,
          },
        ],
      },
      bizCodeSearchItems: {
        header: ["SVC_DIR"],
        data: [
          {
            SVC_DIR: "",
          },
        ],
      },
      codeSearchItems: {
        header: ["GRP_CODE"],
        data: [
          {
            GRP_CODE: "",
          },
        ],
      },
    };
  },

  methods: {
    getBizCode() {
      this.bizCodeSearchItems.data[0].SVC_DIR = ""; // Do not send direction to get all biz code. comment by April 2020.06.23
      Store.dispatch("common/getBizCode", this.bizCodeSearchItems).then(() => {
        this.businessNameList = [];
        for (let i = 0; i < this.bizCodeList.length; i++) {
          let item = this.bizCodeList[i];
          this.businessNameList.push({
            text: item.SVC_NAME,
            value: item.SVC_ID,
          });
        }
        console.log("--------- Finished to process biz ----------");
        console.log(this.bizCodeList);
      });
    },
    getCode() {
      this.codeSearchItems.data[0].GRP_CODE = "B02";
      Store.dispatch("common/getCode", this.codeSearchItems).then(() => {
        this.typeList = [
          {
            text: "",
            value: "",
          },
        ];
        for (let i = 0; i < this.codeList.length; i++) {
          let item = this.codeList[i];
          this.typeList.push({
            text: item.CM_CODE_NAME,
            value: item.CM_CODE_ID,
          });
        }
      });
    },
    clickBrowseFlatFile() {
      this.$refs.flatfile_layout_input.click();
    },
    clickBrowseCsvFile() {
      this.$refs.csv_file_input.click();
    },
    onSave() {
      // 03705_FlatFile Layout Manager_fix Issues 5,6
      let validResult = this.$refs.form.validate();
      if (validResult) {
        if (this.options.item.action == "add") {
          let checkNameCustId = this.mainGrid.filter(e => e.MST_CUST_ID == $cookies.get('comp-id') && e.FFL_FILE_NAME == this.addFlatFileLayoutHeader.data[0].FFL_FILE_STR);
          if(checkNameCustId.length > 0) {
            this.$emit('validate-popup');
            return;
          }
          let checkName = this.mainGrid.filter(e => e.FFL_FILE_NAME == this.addFlatFileLayoutHeader.data[0].FFL_FILE_STR);
          if(checkName.length > 0) {
            console.log('checkName',checkName)
            Store.dispatch(
              "fflayout/saveAddFFLayout",
              this.addFlatFileLayoutHeader
            ).then(() => {
              this.$emit('blocked-item', {custId: $cookies.get('comp-id'), fileName: this.addFlatFileLayoutHeader.data[0].FFL_FILE_STR});
              this.removeDialog({ reload: true });
            });
          } else {
            Store.dispatch(
              "fflayout/saveAddFFLayout",
              this.addFlatFileLayoutHeader
            ).then(() => {
              this.removeDialog({ reload: true });
            });
          }
        } else {
          this.updateFlatFileLayoutHeader.data[0].FFL_PRCS_NO = this.addFlatFileLayoutHeader.data[0].FFL_PRCS_NO;
          this.updateFlatFileLayoutHeader.data[0].CUST_ID = this.addFlatFileLayoutHeader.data[0].CUST_ID;
          this.updateFlatFileLayoutHeader.data[0].USER_ID = $cookies.get(
            "comp-id"
          );
          this.updateFlatFileLayoutHeader.data[0].SVC_ID = this.addFlatFileLayoutHeader.data[0].SVC_ID;
          this.updateFlatFileLayoutHeader.data[0].CSV_FILE_NAME = this.addFlatFileLayoutHeader.data[0].CSV_FILE_NAME;
          this.updateFlatFileLayoutHeader.data[0].CSV_FILE_ID = this.addFlatFileLayoutHeader.data[0].CSV_FILE_ID;
          this.updateFlatFileLayoutHeader.data[0].csvfile = this.addFlatFileLayoutHeader.data[0].csvfile;
          this.updateFlatFileLayoutHeader.data[0].FFL_FRMT_TP = this.addFlatFileLayoutHeader.data[0].FFL_FRMT_TP;
          Store.dispatch(
            "fflayout/modifyFFLayout",
            this.updateFlatFileLayoutHeader
          ).then(() => {
            console.log("--------- Finished to process ----------");
            this.removeDialog({ reload: true });
          });
        }
      } else {
        if (!this.$refs.comment_textfield.validate()) {
          this.$refs.comment_textfield.focus();
        }
        return validResult;
      }
    },
    onFlatFileChanged(e) {
      this.addFlatFileLayoutHeader.data[0].FFL_FILE_STR =
        e.target.files[0].name;
      this.addFlatFileLayoutHeader.data[0].fflfile = e.target.files[0];
    },
    onCsvFileChanged(e) {
      this.addFlatFileLayoutHeader.data[0].CSV_FILE_STR =
        e.target.files[0].name;
      this.addFlatFileLayoutHeader.data[0].csvfile = e.target.files[0];
    },
    removeDialog(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
      if (dialog && dialog.reload) {
        this.$emit("search");
      }
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
  },

  created() {
    // By April to Show EDI Asset depending on Authority.
    // Check whether entered from repository menu on top selection of customer or User menu
    if(cfg.isDlbMybatis) {
      if($cookies.get('login-user-comp-id') == cfg.provider) this.ACCESS_REPO_YN = 'Y';
      else this.ACCESS_REPO_YN = 'N';
    } else {
      if(this.repomenuMode) {
        // Repository Menu
        // if($cookies.get('comp-id') == cfg.provider) this.ACCESS_REPO_YN = 'NY'; // CLT Super Provider
        if($cookies.get('login-user-comp-id') == cfg.provider) this.ACCESS_REPO_YN = 'NY'; // CLT Super Provider
        else this.ACCESS_REPO_YN = 'YN';  // Normal User Admin
      }else {
        // Normal User
        this.ACCESS_REPO_YN = 'NN';
      }
    }

    this.addFlatFileLayoutHeader.data[0].ADMIN_YN = this.ACCESS_REPO_YN;
    this.addFlatFileLayoutHeader.data[0].CUST_ID = $cookies.get("comp-id");
    if (this.options.item.action != "add") {
      let data = this.options.item.data;
      this.addFlatFileLayoutHeader.data[0].CHKIN_COMT = data.CHKIN_COMT;
      this.addFlatFileLayoutHeader.data[0].CSV_FILE_ID = data.FFL_CSV_FILE_ID;
      this.addFlatFileLayoutHeader.data[0].CSV_FILE_NAME =
        data.FFL_CSV_FILE_NAME;
      this.addFlatFileLayoutHeader.data[0].FFL_FILE_NAME = data.FFL_FILE_NAME;
      this.addFlatFileLayoutHeader.data[0].CSV_FILE_STR =
        data.FFL_CSV_FILE_NAME;
      this.addFlatFileLayoutHeader.data[0].FFL_FILE_STR = data.FFL_FILE_NAME;
      this.addFlatFileLayoutHeader.data[0].SVC_ID = data.SVC_ID;
      this.addFlatFileLayoutHeader.data[0].FFL_PRCS_NO = data.FFL_PRCS_NO;
      this.addFlatFileLayoutHeader.data[0].FFL_FRMT_TP = data.FFL_FRMT_TP;
    }
    // this.contenInput = '';
    this.getBizCode();
    this.getCode();
  },

  mounted() {
    setTimeout(() => {
      this.$refs.comment_textfield.focus();
    }, 300);
  },

  watch: {},
};
</script>
<style>
.v-text-field.v-text-field--enclosed.pl-select {
  padding-left: 2px;
}
</style>